export default (classes) => ({
    init() {
        this.setWidth();
    },
	setWidth() {
        this.$root.classList.remove(classes);
		this.$root.style = "";
		let container = document.querySelector(".container");
		let containerWidth = container.getBoundingClientRect().width;
		let space = ((window.outerWidth - containerWidth) / 2) - this.getScrollBarWidth();
		let elWidth = this.$root.getBoundingClientRect().width;

		this.$root.style.width = elWidth - space + "px";
	},
	getScrollBarWidth() {
		let el = document.createElement("div");
		el.style.cssText =
			"overflow:scroll; visibility:hidden; position:absolute;";
		document.body.appendChild(el);
		let width = el.offsetWidth - el.clientWidth;
		el.remove();
		return width;
	},
});
